const defaultState = {
  open: false,
  installation: {
    installationId: null,
    siteName: "",
    gameName: "",
    manufacturer: "",
    assetNo: "",
  },
};

const LiveFloorViewDetailsModalReducer = (state = defaultState, action) => {
  switch (action.type) {
    case "LIVE_FLOOR_VIEW_DETAILS_MODAL":
      return { ...defaultState, ...action.payload };
    default:
      return state;
  }
};
export default LiveFloorViewDetailsModalReducer;
